module.exports = __webpack_public_path__ + "img/33.5f801065.png";